module.exports = __webpack_public_path__ + "static/Roboto-BoldItalic-e17f165e770b67aecddb6c825e6f1ceb.woff";